import { CurrentUserStore } from '../../store/childStore/currentUserStore';
import { MacroStore } from '../../store/childStore/macroStore';
import { PluginStore } from '../../store/childStore/pluginStore';
import { SecurityStore } from '../../store/childStore/securityStore';
import { TabStore } from '../../store/childStore/tabStore';
import { TicketFormUtilStore } from '../../store/childStore/ticketFormUtilStore';
import { UtilStore } from '../../store/childStore/utilStore';
import RootStore from '../../store/provider/RootStoreProvider';
import { RootStore as IRootStore } from '../../store/rootStore';

const getStore = (): IRootStore => RootStore;

type storeName = keyof Omit<IRootStore, 'hydrate' | 'resetStores'>;
const getChildStore: <T extends storeName>(storeName: T) => IRootStore[T] = (storeName) => getStore()[storeName];

export const getCurrentUserStore = (): CurrentUserStore => getChildStore('CurrentUserStore');
export const getMacroStore = (): MacroStore => getChildStore('MacroStore');
export const getTabStore = (): TabStore => getChildStore('TabStore');
export const getPluginStore = (): PluginStore => getChildStore('PluginStore');
export const getSecurityStore = (): SecurityStore => getChildStore('SecurityStore');
export const getTicketFormUtilityStore = (): TicketFormUtilStore => getChildStore('TicketFormUtilStore');
export const getUtilityStore = (): UtilStore => getChildStore('UtilStore');

export default getStore;
